// const routes = [
export default [
  {
    path: "/",
    redirect: "/login",
    hidden: true,
    meta: { menuShow: false },
  },
  {
    path: "/login",
    name: "Login",
    hidden: true,
    component: () => import("@/components/Login"),
    meta: { menuShow: false },
    children: [
      {
        path: "/login/createPassword",
        component: () => import("@/components/users/CreatePwd"),
        meta: { menuShow: false },
      },
    ],
  },
];
// // 递归处理嵌套的子路由的 path 属性
// const addPrefixToRoutes = (routes, prefix) => {
//   return routes.map((route) => {
//     const modifiedRoute = {
//       ...route,
//       path: `${prefix}${route.path}`,
//     };
//     if (route.children) {
//       modifiedRoute.children = addPrefixToRoutes(route.children, `${prefix}`);
//     }
//     return modifiedRoute;
//   });
// };

// const prefixedRoutes = addPrefixToRoutes(routes, "/en");

// export default prefixedRoutes;
